import { IBenchmarkFilters } from '@mg-platform/reports/reports-data-access'
import { IEnterpiseBenchmarkItem } from '../../interfaces/enterprise-benchmark.interface'

export interface EnterpriseBenchmarkStateModel {
  benchmarks: IEnterpiseBenchmarkItem[]
  benchmarksFilters: IBenchmarkFilters
}
